import { render, staticRenderFns } from "./agenzie.vue?vue&type=template&id=ddbac5b6&"
import script from "./agenzie.vue.ts?vue&type=script&lang=ts&"
export * from "./agenzie.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports